import { combineReducers } from "redux";
import user from "./user.reducer";
import login from "./login.reducer";
import register from "./register.reducer";
import captcha from "./captcha.reducer";
import confirm from "./confirm.reducer";
import resendToken from "./resendToken.reducer";
import forgot from "./forgot.reducer";
import resetPass from "./resetPass.reducer";

const authReducers = combineReducers({
  user,
  login,
  register,
  captcha,
  confirm,
  resendToken,
  forgot,
  resetPass,
});

export default authReducers;
